import React from 'react';
import PropTypes from 'prop-types';
import style from './CodeExamples.scss';
import { MultipleExamples } from './MultipleExamples';
import classnames from 'classnames';
import { SingleExample } from './SingleExample';

export const CodeExamples = ({ data, prefix, JSLayoutType = false }) => {
  const examples = (data?.docs?.examples || []).filter(isValidExample);
  const hasExamples = examples && examples.length > 0;
  const classNames = classnames({
    [style.codeExamples]: true,
    [style.noExamples]: !hasExamples,
  });
  const stickyClassNames = classnames({
    [style.stickyContainer]: true,
    [style.noExamples]: !hasExamples,
  });

  return (
    <>
      {hasExamples && (
        <div className={classNames} data-hook="code-examples">
          <div className={stickyClassNames}>
            {examples.length > 1 ? (
              <MultipleExamples
                examples={examples}
                data={data}
                prefix={prefix}
                isSingleExample={examples.length < 2}
                JSLayoutType={JSLayoutType}
              />
            ) : (
              <SingleExample
                example={examples[0]}
                data={data}
                prefix={prefix}
                isSingleExample={examples.length < 2}
                JSLayoutType={JSLayoutType}
              />
            )}
          </div>
        </div>
      )}
    </>
  );

  function isValidExample(example) {
    return example.body && example.body.length > 0;
  }
};

CodeExamples.propTypes = {
  data: PropTypes.any,
  prefix: PropTypes.string,
};
